var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUspBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.71728 4.02998L6.50019 6.79789L11.2506 4.04621",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.799781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.50007 11.7053V6.79241",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.799781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.37881 1.34333L2.48631 2.9521C1.8309 3.31502 1.29466 4.22501 1.29466 4.97251V8.03294C1.29466 8.78044 1.8309 9.69043 2.48631 10.0533L5.37881 11.6621C5.99631 12.0034 7.00923 12.0034 7.62673 11.6621L10.5192 10.0533C11.1747 9.69043 11.7109 8.78044 11.7109 8.03294V4.97251C11.7109 4.22501 11.1747 3.31502 10.5192 2.9521L7.62673 1.34333C7.00381 0.996667 5.99631 0.996667 5.37881 1.34333Z",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.799781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.2082 7.17173V5.18924L4.06779 2.22089",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.799781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspBox);
export default __webpack_public_path__ + "static/media/usp-box.57bc697025dfe121d4d536141ab885c1.svg";
export { ForwardRef as ReactComponent };